<!--<app-tenant-as *ngIf="showTenantAs"></app-tenant-as>-->
<app-login-as *ngIf="showLoginAs()"></app-login-as>
<app-navbar [ngClass]="showHeader() ? '' : 'd-none'"></app-navbar>
<router-outlet></router-outlet>
<app-footer *ngIf="showFooter()"></app-footer>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<app-spinner></app-spinner>